export default __webpack_public_path__ + "static/media/adddwdw.e25d2fa7.svg";